import { Image } from '@ahafood/ui/components/image';
import { Sparkles } from 'lucide-react';
import React from 'react';

type NewGreetingCardProps = {
  userName?: string;
};

export default function NewGreetingCard({ userName }: NewGreetingCardProps) {
  const displayName =
    userName && userName !== 'Ahamove User' ? userName : 'Bạn';

  return (
    <div className="relative px-4 pt-4 pb-2">
      {/* Subtle AI sparkle — gợi cảm giác AI/magic */}
      <Sparkles
        aria-hidden
        className="absolute top-4 right-4 size-5 text-primary-30/70"
      />

      {/* Tagline — clean single-tone text + SOLO MEAL pill */}
      <div className="flex items-center gap-1.5 text-xs font-medium text-neutral-60">
        Một mình? Có Amori! Một bữa có
        <Image
          width={71}
          height={21}
          src="/static/images/solo-meal.png"
          alt="Solo Meal"
        />
      </div>

      {/* Main heading — single-direction gradient flow (warm orange → red) */}
      <h2 className="mt-1.5 text-2xl font-black tracking-tight bg-gradient-to-r from-[#FF7F32] via-[#FF4E5E] to-[#A80036] bg-clip-text text-transparent w-fit">
        {displayName} muốn ăn gì?
      </h2>
    </div>
  );
}
